// extracted by mini-css-extract-plugin
export default {"mid-box":"MembershipFailed_mid-box__Pt4xG","top":"MembershipFailed_top__ErmTX","mid":"MembershipFailed_mid__sXxsc","botm":"MembershipFailed_botm__L1LiP"};